<template>
  <Frontendlayout>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item active">Offers List</li>
        </ol>
        <div class="box_general">
          <div class="header_box">
            <h2 class="d-inline-block">All Offers</h2>
          </div>
          <div class="list_general">
            <JqueryTable />
          </div>
        </div>
        <!-- /box_general-->
      </div>
      <!-- /.container-fluid-->
    </div>
  </Frontendlayout>
</template>
<script>
import JqueryTable from "@/cmps/JqueryTable.vue";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
export default {
  name: "App",
  components: {
    JqueryTable,
    Frontendlayout,
  },
};
</script>
